/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext } from 'react';
import './effortUpload.scss';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import ButtonComponent from '../../../Components/Button/button';
import { EFFORT_UPLOAD } from '../../../Constants/strings';
import RunEffortUploadForm from './runEffortUpload';
import { AuthContext } from '../../../Contexts/AuthContext';
import CustomDateRangePicker from '../../../Components/DateRangePicker/dateRangePicker';
import {Select} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import dayjs from 'dayjs';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import UseAxios from '../../../Api/http/http';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import { MODULE_NAMES } from '../../../Constants/modules';
import { effortUploadList } from '../../../Api/request/effortUpload';
const EffortUpload = () => {
  const [rows, setRows] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const { userProfile } = useContext(AuthContext);
  const [isMobileView, setIsMobileView] = useState(false);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.CONFIGURATION_EFFORT_UPLOAD] || []
    : [];
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [anchorNewEl, setAnchorNewEl] = React.useState(null);
  const { snackbarOpen } = useSnackbar();

  // Open the date picker popover
  const handleClick = (event) => {
    setAnchorNewEl(event.currentTarget);
  };

  // Close the date picker popover
  const handleCloseDatePicker = () => {
    setAnchorNewEl(null);
  };

  // Handle the change in date range
  const handleChangeDate = ([newStartDate, newEndDate]) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const checkAccess = (action) => {
    return permission.includes(action);
  };

  const fetchEffortHistory = (startDateVal, endDateVal) => {
    let apiCall = null;
    if (startDateVal && endDateVal) {
      const selectedStartDate = dayjs(startDateVal).format('DD-MM-YYYY');
      const selectedEndDate = dayjs(endDateVal).format('DD-MM-YYYY');
      apiCall = effortUploadList(selectedStartDate, selectedEndDate);
    } else {
      apiCall = effortUploadList();
    }

    UseAxios(apiCall)
      .then((response) => {
        if (response.data?.response?.data?.statusCode == STATUS_CODES.NO_DATA){
          setRows([]);
        }
        const effortHistory = response.data.schedulerHistory;
        setRows(effortHistory);
      })
      .catch((error) => {
        snackbarOpen(EFFORT_UPLOAD.OOPS_TRY_AGAIN, 'warning');
        setRows([]);
        console.error(error);
      });
  };

  useEffect(() => {
    fetchEffortHistory(startDate, endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
  };

  const updateEffortList = () => {
    fetchEffortHistory();
  };

  const filteredRows = rows || [];

  // Check if first entry has 'In progress' status
  const isFirstEntryInProgress = filteredRows.length > 0 && filteredRows[0]?.status === 'In progress';

  const getColumnWidth = (mobileView, mobileWidth, desktopWidth) => {
    return mobileView ? mobileWidth : desktopWidth;
  };

  const getColumnFlex = (mobileView, mobileFlex, desktopFlex) => {
    return mobileView ? mobileFlex : desktopFlex;
  };

  const columns = [
    {
      field: EFFORT_UPLOAD.UPDATED_START_DATE,
      headerName: EFFORT_UPLOAD.UPLOADED_START_TIME,
      flex: getColumnFlex(isMobileView, undefined, 0.22),
      width: getColumnWidth(isMobileView, 200, undefined),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => dayjs(params).format('DD/MM/YYYY h:mm:ss A'),
      showDateFilter: true, // Show date filter for this column
      showTextFilter: false, // Hide text filter for this
    },
    {
      field: EFFORT_UPLOAD.UPDATED_END_DATE,
      headerName: EFFORT_UPLOAD.UPLOADED_END_TIME,
      flex: getColumnFlex(isMobileView, undefined, 0.2),
      width: getColumnWidth(isMobileView, 190, undefined),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => {
        const date = dayjs(params);
        return date.isValid() ? date.format('DD/MM/YYYY h:mm:ss A') : '-';
      },
      showDateFilter: true,
      showTextFilter: false,
    },
    {
      field: EFFORT_UPLOAD.START_DATE,
      headerName: EFFORT_UPLOAD.EFFORT_START_DATE,
      flex: getColumnFlex(isMobileView, undefined, 0.2),
      width: getColumnWidth(isMobileView, 160, undefined),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => dayjs(params).format('DD MMM, YYYY'),
      showDateFilter: true,
      showTextFilter: false,
    },
    {
      field: EFFORT_UPLOAD.END_DATE,
      headerName: EFFORT_UPLOAD.EFFORT_END_DATE,
      flex: getColumnFlex(isMobileView, undefined, 0.2),
      width: getColumnWidth(isMobileView, 160, undefined),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => dayjs(params).format('DD MMM, YYYY'),
      showDateFilter: true,
      showTextFilter: false,
    },
    {
      field: EFFORT_UPLOAD.RUN_BY,
      headerName: EFFORT_UPLOAD.EFFORT_RUN_BY,
      flex: getColumnFlex(isMobileView, undefined, 0.14),
      width: getColumnWidth(isMobileView, 110, undefined),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: EFFORT_UPLOAD.STATUS,
      headerName: EFFORT_UPLOAD.EFFORT_STATUS,
      flex: getColumnFlex(isMobileView, undefined, 0.15),
      width: getColumnWidth(isMobileView, 120, undefined),
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        let className = '';
        switch (params.value) {
        case 'Completed':
          className = 'status-completed';
          break;
        case 'In progress':
          className = 'status-in-progress';
          break;
        case 'Failed':
          className = 'status-failed';
          break;
        default:
          className = '';
        }
        return <span className={className}>{params.value}</span>;
      },
    },
  ];

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
    columns[5].field,
  ];

  // Define the handleCloseSnackbar function
  return (
    <div className="effort-upload-outer-layer">
      <div className="effort-upload">
        <div className="effort-upload-title">
          {EFFORT_UPLOAD.EFFORT_UPLOAD_TITLE}
        </div>
        <div className="effort-search-and-buttons">
          <div className="effort-search-dropdown">
            <div className='effort-date-range'>
              <Select
                value={startDate && endDate ? `${startDate.format('DD MMM, YYYY')} - ${endDate.format('DD MMM, YYYY')}` : ''}
                onClick={handleClick} // Open the picker on click
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                readOnly
                inputProps={{
                  'aria-label': 'Select Date Range',
                }}
                renderValue={(selected) => selected || `${EFFORT_UPLOAD.CUSTOM_DATE_PLACEHOLDER}`}
              >
              </Select>
            </div>
          </div>

          {/* CustomDateRangePicker is used to show date pickers */}
          <CustomDateRangePicker
            anchorEl={anchorNewEl}
            onClose={handleCloseDatePicker}
            onChange={handleChangeDate} // Pass onChange to handle date updates
            startDate={startDate}
            endDate={endDate}
          />
          <div className="effort-button">
            <div className="run-effort-uplaod-btn">
              <ButtonComponent
                disabled={!checkAccess('create') || isFirstEntryInProgress} // Disable if no permission or first entry is in progress
                label={EFFORT_UPLOAD.RUN_EFFORT_UPLOAD}
                variant="contained"
                onClick={() => {
                  setAddModalOpen(true);
                  setIsEdit(false);
                }}
                btnCss={
                  !checkAccess('create') || isFirstEntryInProgress
                    ? 'run-effort-btn-disabled'
                    : 'run-effort-btn'
                }
              ></ButtonComponent>
            </div>
            <RunEffortUploadForm // add popup common component
              openAddModal={addModalOpen}
              handleClose={() => {
                setAddModalOpen(false);
              }}
              runBy={userProfile?.user_name}
              setRows={updateEffortList}
            />
          </div>
        </div>
        <div className="data-grid-container">
          {filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={columns}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isFilteredRows={filteredRows}
              isEdit={isEdit}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default EffortUpload;
